const useIsFreelancerLoggedIn = (): boolean => {
  return !!window.is_authenticated;
};

export default useIsFreelancerLoggedIn;
